import Mask from '__components/Mask';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { isIPad } from 'emrn-design/isIPad';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image, ScrollView } from 'react-native';

interface Props {
  ruleText?: string;
}

interface State {
  isShow: boolean;
}

export class RulePop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  show = () => {
    this.setState({ isShow: true });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { ruleText } = this.props;
    const { isShow } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <LinearGradient
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 0.19 }}
                colors={['#FFF7C2', '#FFFFFF']}
                style={styles.main}
              >
                <Spacer size={rpx(24)} />
                <Image
                  style={styles.ruleTitle}
                  source={require('../../images/invite/ruleTitle.png')}
                  resizeMode={'stretch'}
                />
                <Spacer size={rpx(10)} />
                <ScrollView style={styles.main_c}>
                  <Text style={styles.text}>{ruleText}</Text>
                </ScrollView>
              </LinearGradient>
              <EmTouchableOpacity
                onPress={() => {
                  this.hide();
                }}
              >
                <Image
                  style={styles.closeImg}
                  source={require('../../images/invite/closeBtn.png')}
                  resizeMode={'stretch'}
                />
              </EmTouchableOpacity>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    width: rpx(300),
    height: isIPad ? rpx(350) : rpx(500),
    backgroundColor: '#fff',
    borderRadius: rpx(32),
    alignItems: 'center',
    paddingHorizontal: rpx(25),
    paddingBottom: rpx(20),
  },
  main_c: {
    height: isIPad ? rpx(300) : rpx(420),
  },
  text: {
    fontSize: rpx(12),
    color: '#333333',
    lineHeight: rpx(24),
    textAlign: 'justify',
    textAlignVertical: 'center',
  },
  ruleTitle: {
    width: rpx(93.5),
    height: rpx(21.5),
  },
  Tittext: {
    fontSize: rpx(20),
    color: '#3A5DD7',
    fontWeight: 'bold',
  },
  closeImg: {
    marginTop: rpx(20),
    width: rpx(56),
    height: rpx(41),
  },
});
